import SelectController from "@/common/components/SelectController";
import TextField from "@/common/components/TextField";
import { Control, FieldErrors, UseFormRegister } from "react-hook-form";
import { CompanyBranchData } from "@/common/types/companyBranches.type";
import { Mapper } from "@/common/services/mapper";
import useDebounce from "@/common/hooks/useDebounce";
import { CompanyBranchValidationSchema } from "../../schemas/companyBranch.schema";
import { useAvailableCompanyBranches } from "../../hooks/useAvailableCompanyBranches";

export type BranchInformationProps = {
  branchId?: string;
  register: UseFormRegister<CompanyBranchValidationSchema>;
  errors: FieldErrors<CompanyBranchValidationSchema>;
  control: Control<CompanyBranchValidationSchema, any>;
  companyId?: string;
  disableFields?: boolean;
  parentId?: string;
  showParentIdField?: boolean;
};

export const BranchInformation = ({
  branchId,
  register,
  errors,
  control,
  disableFields,
  parentId,
  showParentIdField
}: BranchInformationProps) => {
  const [searchCompanyBranch, setSearchCompanyBranch] = useDebounce("");

  const { data: companyBranchOptions } = useAvailableCompanyBranches({
    filters: { search: searchCompanyBranch },
    mapper: Mapper.mapToOptions<CompanyBranchData>({ labelFieldName: 'display_name', valueFieldName: 'id' }),
  });

  return (
    <div className="flex gap-2 w-full justify-between">
      <TextField
        label="Nome da filial"
        maxLength={64}
        errorMessage={errors.display_name?.message || undefined}
        className="w-full"
        {...register('display_name')}
        markAsRequired={!disableFields}
        disabled={!parentId || disableFields}
      />

      {showParentIdField && (
        <SelectController
          control={control}
          name="parent"
          label="Filial Mãe"
          className="w-full"
          errorMessage={errors?.parent?.message || undefined}
          options={
            branchId
              ? companyBranchOptions.filter((item) => item.value !== branchId) || []
              : companyBranchOptions || []
          }
          onInputChange={setSearchCompanyBranch}
          markAsRequired={!disableFields}
          isDisabled={disableFields}
        />
      )}
    </div>
  );
};
